import { GetActivityLogStatus } from "@/helper/activityLogHelper";

export function ConvertToActivityLog(activityLogRawList: Array<any>) {
  const activityLogList: Array<any> = [];

  if (activityLogRawList && activityLogRawList.length > 0) {
    activityLogRawList.forEach((activityLogRaw) => {
      const activityLogActionDescription = GetActivityLogStatus(
        activityLogRaw.logTypeDisplayModel.id,
        activityLogRaw.module.id,
        activityLogRaw.status
      );
      activityLogList.push({
        actionEventModel: activityLogRaw.actionEventModel,
        logTimeStamp: activityLogRaw.logTimeStamp,
        logTypeDisplayModel: activityLogRaw.logTypeDisplayModel,
        module: activityLogRaw.module,
        referenceId: activityLogRaw.referenceId,
        userId: activityLogRaw.userId,
        text: activityLogActionDescription.text,
        classText: activityLogActionDescription.classText,
        classIconText: activityLogActionDescription.classIconText,
      });
    });
  }

  return activityLogList;
}
